import React from 'react'
import ReactDOM from 'react-dom'
import FieldErrors from './FieldErrors'
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'

class LogoUploader extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      uploading: false
    }
  }

  removeFile = (file) => {
    this.props.setData({logo: null})
  }

  handleChange = (event) => {
    if(event.target.files[0]) this.uploadFile(event.target.files[0])
  }

  uploadFile = (file) => {
    this.setState({uploading: true})

    const data = new FormData()
    data.append('logo', file)
    axios.post(this.props.uploadUrl, data).then((resp) => {
      this.props.setData({logo: resp.data.welcome_company.logo})
      this.setState({uploading: false})
    }).catch((resp) => {
      this.setState({uploading: false})
      alert(resp.response && resp.response.data && resp.response.data.error || "There was an error uploading your file please try again.")
    })
  }

  render() {
    const colClass = "file-uploader-size"

    return (
      <div className="">
        <p className="p-sm">PNG, JPEG, GIF, or WebP. Maximum 10 MB.</p>
        {this.props.logo &&
          <div className="file-uploader__front remove file-uploader__cover" style={{marginBottom: "10px"}}>
            <a href={this.props.logo.url} target="_blank">{this.props.logo.filename}</a>
            <span onClick={this.removeFile} style={{marginLeft: "8px"}}>
              <i className="fa fa-times"></i>
              [<span className="canaan-blue" style={{cursor: "pointer"}}><strong>Remove</strong></span>]
            </span>
          </div>
        }
        {this.state.uploading &&
          <div className={colClass}>
            Uploading
          </div>
        }

        <div className="custom-file file-uploader">
          <input type="file" className="custom-file-input" id="customFile" accept="image/png,image/jpeg,image/gif,image/webp" onChange={this.handleChange} />
          <label className="custom-file-label button button-large" htmlFor="customFile">Upload logo</label>
        </div>
      </div>
    )
  }
}

export default LogoUploader
